export function buildUrlPath(navbarItems, navbarItemId) {
    function findItemById(items, id) {
        for (const item of items) {
            if (item.id === id) return item;
            if (item.children && item.children.length > 0) {
                const found = findItemById(item.children, id);
                if (found) return found;
            }
        }
        return null;
    }

    const item = findItemById(navbarItems, navbarItemId);
    if (!item) return '/';

    const type = item.type || 'null';
    let pathSegments = [item.name.toLowerCase().replace(/\s+/g, '-')];

    let currentItem = item;
    while (currentItem.parent_item) {
        const parent = findItemById(navbarItems, currentItem.parent_item);
        if (parent) {
            pathSegments.unshift(parent.name.toLowerCase().replace(/\s+/g, '-'));
            currentItem = parent;
        } else {
            break;
        }
    }

    pathSegments.unshift(type);
    return '/' + pathSegments.join('/');
}